import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledLeadPriorityChip = styled.div<{ textColor: string }>`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  min-width: 70px;
  max-width: 150px;
  height: 24px;
  border-radius: 19px;
  border: 1px solid ${colorsPalettes.carbon[100]};
  padding: 0 12px;
  gap: 8px;
  margin-left: auto;
  white-space: nowrap;
  ${setFontVariant('sectionTitle')};
  color: ${({ textColor }) => textColor};
`;

export const StyledBarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  width: 19px;
  height: 13px;
  margin-bottom: 2px;
`;

export const StyledBarItem = styled.div<{ height: number; color: string }>`
  width: 5px;
  height: ${(props) => props.height}px;
  background-color: ${(props) => props.color};
  border-radius: 1px 1px 0 0;
`;
